/* ==========================================================================
   comparison-slider-component — before/after image wipe.
   Mirrors the live implementation: a range input drives the --compare
   custom property; both layers occupy one grid cell and are revealed by
   complementary clip-path insets. Plays a 50→40→60→50 intro sweep the
   first time the component scrolls into view.
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('comparison-slider-component')) return;

  class ComparisonSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.hasAnimated = false;
      this.isAnimating = false;
    }

    connectedCallback() {
      this.mediaWrapper = this.querySelector('[ref="mediaWrapper"]');
      this.slider = this.querySelector('[ref="slider"]');
      this.afterImage = this.querySelector('[ref="afterImage"]');
      if (!this.mediaWrapper || !this.slider || !this.afterImage) return;

      this.orientation = this.mediaWrapper.dataset.orientation || 'horizontal';
      this.boundSync = this.sync.bind(this);
      this.slider.addEventListener('input', this.boundSync);
      this.slider.addEventListener('pointerdown', this.boundSync);
      this.sync();
      this.setupIntersectionObserver();
    }

    disconnectedCallback() {
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
    }

    sync() {
      if (this.isAnimating) return;
      var val =
        (Number(this.slider.value) - Number(this.slider.min)) /
        (Number(this.slider.max) - Number(this.slider.min));
      this.mediaWrapper.style.setProperty('--compare', String(Math.round(val * 100)));
    }

    setValue(value) {
      if (!this.slider) return;
      this.slider.value = String(value);
      this.sync();
    }

    animateSlider() {
      if (this.hasAnimated) return;
      this.hasAnimated = true;
      this.isAnimating = true;
      var wrapper = this.mediaWrapper;
      var slider = this.slider;
      var self = this;
      wrapper.style.setProperty('--transition-duration', '0.5s');
      setTimeout(function () { wrapper.style.setProperty('--compare', '40'); }, 100);
      setTimeout(function () { wrapper.style.setProperty('--compare', '60'); }, 600);
      setTimeout(function () { wrapper.style.setProperty('--compare', '50'); }, 1100);
      setTimeout(function () {
        wrapper.style.setProperty('--transition-duration', '0s');
        slider.value = '50';
        self.isAnimating = false;
      }, 1600);
    }

    setupIntersectionObserver() {
      if (!('IntersectionObserver' in window)) return;
      var self = this;
      this.intersectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.animateSlider();
              self.intersectionObserver.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );
      this.intersectionObserver.observe(this);
    }
  }

  customElements.define('comparison-slider-component', ComparisonSliderComponent);
})();
